<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Solomon
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that Jesus is the truly wise and faithful Son of David who will rule God’s people forever.
                        </li>
                        <li>
                            To understand that God dwells with his people in the person of Jesus, the new and better temple than the one that Solomon built.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series covers the rise and fall of King Solomon. His reign started very well as he looked to the Lord to
                        provide the wisdom necessary for him to rule (week 1). His great wisdom was internationally recognised and his reign brought
                        peace and vast wealth to Israel (week 3). It culminated in the building of a magnificent temple where God could dwell in the
                        midst of his people (week 2). However, later in life Solomon’s heart was led astray to worship idols (week 3).
                        He was a very wise man who acted foolishly. Yet God remained faithful to the promise that he made to David and,
                        although the kingdom was later divided because of Solomon’s sin, he nevertheless kept a king from David’s line on the throne.
                    </p>
                    <p>
                        Solomon is a poor forerunner to Jesus, the wiser temple builder who remained faithful and obedient to the end
                        (Matthew 12:42). By his death and resurrection Jesus has made it possible for God to dwell with his people forever, not in a temple made of stone, but by faith in him (John 2:19-21).
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Solomon's Wisdom (1 Kings 3:1-28)
                    </p>
                    <p>
                        Lesson 2 - Solomon's Temple (1 Kings 8:1-21)
                    </p>
                    <p>
                        Lesson 3 - Solomon's Downfall (Deuteronomy 17:14-20, 1 Kings 10:14 - 11:33)
                    </p>
                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Solomon",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Solomon`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that Jesus is the truly wise and faithful Son of David who will rule God’s people forever.",
                },
            ],
        };
    },
};
</script>
